import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MyOwnCustomMaterialModule } from './materialmodule';

import { AppComponent } from './app.component';
import { DocChoiceComponent } from './components/doc-choice/doc-choice.component';
import { RouteModule } from './route/route.module';
import { CdcStepsComponent } from './components/cdc-steps/cdc-steps.component';
import { HttpClientModule } from '@angular/common/http';
import { DocumentService } from './services/document.service';
import { LoaderComponent } from './common/loader/loader.component';
import { LoaderService } from './common/loader/loader.service';
import { SocieteComponent } from './components/societe/societe.component';
import { ButtonstepComponent } from './components/utils/buttonstep/buttonstep.component';
import { SocieteService } from './services/societe.service';
import { AgmCoreModule } from '@agm/core';
import { GmapplaceComponent } from './components/utils/gmapplace/gmapplace.component';
import { FormsocieteComponent } from './components/societe/formsociete/formsociete.component';
import { HttpService } from './common/utils/http.service';
import { SitemodelComponent } from './components/sitemodel/sitemodel.component';
import { SitemodelService } from './services/sitemodel.service';
import { StateService } from './services/state/state.service';
import { PopinComponent } from './components/utils/popin/popin.component';
import { LoginComponent } from './components/login/login.component';
import { LoginService } from './services/login/login.service';
import { ModulesService } from './services/modules.service';
import { GenericService } from './services/generic.service';
import { InfostechniquesService } from './services/infostechniques.service';
import { ListdocumentComponent } from './components/listdocument/listdocument.component';
import { VerticalSelectImageBoxComponent } from './components/utils/verticalSelectImageBox/verticalSelectImageBox.component';
import { ModulesComponent } from './components/modules/modules.component';

import { keyValuePipe } from './common/utils/pipes/keyvalue.pipe';

/*
  redux modules
*/
import { StoreModule } from "@ngrx/store";
import { metaReducer } from "./common/appstore/index";
import { SocietenamePipe } from './components/societe/societename.pipe';
import { ModuleComponent } from './components/utils/module/module.component';
import { CarreDirective } from './components/utils/module/directive/carre.directive';
import { InfostechniquesComponent } from './components/infostechniques/infostechniques.component';
import { StepsWizardComponent } from './components/steps-wizard/steps-wizard.component';
import { FormWizardComponent } from './components/form-wizard/form-wizard.component';
import { TextAddableComponent } from './components/form/text-addable/text-addable.component';
import { TextInputComponent } from './components/form/text-input/text-input.component';
import { TextareaInputComponent } from './components/form/textarea-input/textarea-input.component';
import { SelectInputComponent } from './components/form/select-input/select-input.component';
import { HorizontalSelectImageComponent } from './components/form/horizontal-select-image/horizontal-select-image.component';
import { VerticalSelectImageComponent } from './components/form/vertical-select-image/vertical-select-image.component';
import { ComboBoxComponent } from './components/form/combo-box/combo-box.component';
import { ToggleInputComponent } from './components/form/toggle-input/toggle-input.component';
import { RadioInputComponent } from './components/form/radio-input/radio-input.component';
import { DatePickerInputComponent } from './components/form/date-picker-input/date-picker-input.component';
import { MAT_DATE_LOCALE } from '@angular/material';




@NgModule({
  declarations: [
    AppComponent,
    DocChoiceComponent,
    CdcStepsComponent,
    LoaderComponent,
    SocieteComponent,
    ButtonstepComponent,
    GmapplaceComponent,
    FormsocieteComponent,
    SitemodelComponent,
    PopinComponent,
    LoginComponent,
    SocietenamePipe,
    ListdocumentComponent,
    VerticalSelectImageBoxComponent,
    ModulesComponent,
    ModuleComponent,
    CarreDirective,
    InfostechniquesComponent,
    keyValuePipe,
    StepsWizardComponent,
    FormWizardComponent,
    TextAddableComponent,
    TextInputComponent,
    TextareaInputComponent,
    SelectInputComponent,
    HorizontalSelectImageComponent,
    VerticalSelectImageComponent,
    ComboBoxComponent,
    ToggleInputComponent,
    RadioInputComponent,
    DatePickerInputComponent
  ],
  entryComponents: [PopinComponent],
  imports: [
    AgmCoreModule.forRoot({
      apiKey: "AIzaSyCcI9ZuQ7tXx6l2VXWqMvZX2l3caAl08fs",
      libraries: ["places"]
    }),
    FlexLayoutModule,
    BrowserModule,
    HttpClientModule,
    RouteModule,
    NoopAnimationsModule,
    MyOwnCustomMaterialModule,
    FormsModule,
    ReactiveFormsModule,
    StoreModule.forRoot({ reducer: metaReducer }),
  ],
  providers: [
    GenericService,
    LoaderService,
    HttpService,
    DocumentService,
    SocieteService,
    SitemodelService,
    StateService,
    LoginService,
    ModulesService,
    InfostechniquesService,
    { provide: MAT_DATE_LOCALE, useValue: 'fr-FR' }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// C:/Users/Quentin/projets/kontractor/src/app/app.module.ts